module.exports = __webpack_public_path__ + "static/media/06.72aaba60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/06.jpg
// module id = 181
// module chunks = 0